import { render } from "./TaskCreateView.vue?vue&type=template&id=378a9158"
import script from "./TaskCreateView.vue?vue&type=script&lang=js"
export * from "./TaskCreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__